import _sfc_main from "./StoryVariantSingle.vue_vue_type_script_setup_true_lang.js";
import "./StoryVariantSingle.vue_vue_type_style_index_0_scoped_ddfc5b4f_lang.js";
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const StoryVariantSingle = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-ddfc5b4f"]]);
export {
  StoryVariantSingle as default
};
